import { Box } from '@chakra-ui/react';

interface IProps {
  children: React.ReactNode;
}

const PageSubtext = (props: IProps) => {
  const { children } = props;
  return (
    <Box mb={6} fontSize="md">
      {children}
    </Box>
  );
};

export default PageSubtext;
